<template>
  <div id="p-url-list">
    <el-table
            :data="tableData"
            style="width: 100%">
      <el-table-column
              prop="type"
              label="类型"
              width="150">
      </el-table-column>
      <el-table-column
              prop="url"
              label="url">
      </el-table-column>
      <el-table-column
              label="操作"
              width="150">
        <template slot-scope="scope">
          <el-button
                  @click.native.prevent="goClick(scope.row, scope.$index)"
                  type="text"
                  size="small">
            进入
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'p-url-list',
  data() {
    return {
      tableData: [
        { type: 'python编辑器', url: `${location.origin}/ide-edit?ip=4264&lang=py` },
        { type: 'python运行', url: `${location.origin}/ide-run?ip=4232&lang=py` },
        { type: 'python预览', url: `${location.origin}/ide-preview?ip=4096&lang=py` },
        { type: 'c编辑器', url: `${location.origin}/ide-edit?ip=4216&lang=c` },
        { type: 'c运行', url: `${location.origin}/ide-run?ip=4120&lang=c` },
        { type: 'c预览', url: `${location.origin}/ide-preview?ip=4096&lang=c` },
      ],
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    goClick(item, index) {
      console.log('-go:', item.url, index)
      this.$router.push(item.url.substr(item.url.lastIndexOf('/')))
      // location.href = item.url;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #p-url-list {
    margin: auto;
    width: 800px;
  }
</style>
